import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ButtonModule } from 'primeng/button';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { DirectionService } from '../app/services/direction.service';
import { ProjectService } from '../app/services/project.service';
import { SocketService } from '../app/services/socket.service';
import { NotificationService } from '../app/services/notification.service';
import { NotificationTypesEnum } from '../app/interfaces';
import { IndicatorsService } from '../app/services/indicators.service';
import { DialogModule } from 'primeng/dialog';
import { WebViewerComponent } from '../app/webviewer/webviewer.component';

@Component({
  selector: 'app-project-file-auditor',
  standalone: true,
  imports: [
    DialogModule,
    WebViewerComponent,
    FormsModule, TableModule, TranslateModule,
    RadioButtonModule, ButtonModule, TooltipModule, TagModule],
  templateUrl: './project-file-auditor.component.html',
  styleUrl: './project-file-auditor.component.scss'
})
export class ProjectFileAuditorComponent implements OnInit {
  @ViewChild('assessmentForm') assessmentForm!: NgForm;
  dir!: 'rtl' | 'ltr';
  locale!: "ar" | "en";
  assessmentModal = false;
  milestones = [] as any[];
  _projectId = 0;
  _selectedStrategyId = 0

  @Output() onFileReviewed = new EventEmitter<string>();
  @Input() set selectedStrategyId(value: number) {

    this._selectedStrategyId = value;
    this.projectService.getProjectMilestoneFilesAuditor(this.selectedStrategyId, this.projectId)
      .subscribe((response: any) => {
        this.milestones = response['data']['milestones'];
      })
  };

  get selectedStrategyId() {
    return this._selectedStrategyId
  }

  project = {} as any
  files = [] as any[];
  selectedFile = {} as any;
  @Input() set projectId(value: number) {
    this._projectId = value;
  }

  get projectId() {
    return this._projectId;
  }
  constructor(
    private projectService: ProjectService,
    private toastr: ToastrService,
    private socketService: SocketService,
    private directionService: DirectionService,
    private notificationService: NotificationService,
    private indicatorService: IndicatorsService
  ) {
  }

  ngOnInit(): void {
    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
      this.locale = dir == "rtl" ? "ar" : "en";
    })

  }

  openAssessmentModal(file: any) {
    this.assessmentModal = true;
    console.log("file", 'trimming');
    this.selectedFile = { ...file, comments: file.comments.trim() };
  }

  closeAssessmentModal() {
    this.assessmentModal = false;
    this.selectedFile = null;
  }

  getFileIcon(type: string) {
    switch (type) {
      case 'image/jpeg':
      case 'image/png':
        return "fa-solid fa-file-image";
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        return "fa-solid fa-file-word";
      case 'application/pdf':
        return "fa-solid fa-file-pdf";
      case 'video/mp4':
      case 'video/x-msvideo':
      case 'video/quicktime':
      case 'video/x-matroska':
        return "fa-solid fa-file-video";
      default:
        return "fa-solid fa-file";
    }
  }

  MediaFileStatusEnum = {
    pending: 'pending',
    approved: 'approved',
    rejected: 'rejected'
  };

  FileStatusValues = {
    pending: "قيد المراجعة",
    approved: "معتمد",
    rejected: "مرفوض"
  };

  assessOutput() {
    this.projectService.reviewAuditFile(this.selectedStrategyId, { ... this.selectedFile, fileType: this.selectedFile.entityType }).subscribe((response: any) => {
      this.assessmentModal = false;
      console.log("this.milestones########", this.milestones);
      const milestone = this.milestones.find(x => x.id == this.selectedFile.subEntityId)
      if (milestone) {
        const mappedFiles = milestone.files.map((x: any) => x.id == this.selectedFile.id ? { ...this.selectedFile } : x)
        milestone.files = mappedFiles
        this.milestones = this.milestones.map((x: any) => x.id == this.selectedFile.project_id ? { ...milestone } : x)
        this.toastr.success(response['data']['message'])
      }
      this.socketService.connect();
      this.onFileReviewed.emit();

      this.notificationService.pushAuditRequest(
        this._selectedStrategyId, {
        id: this.selectedFile.id,
        parentEntityId: this.projectId,
        subEntityId: this.selectedFile.subEntityId,
        type: NotificationTypesEnum.milestone_output_audit_response
      },
        this.locale
      )
    })
  };
  isFileViewer = false;
  openFileViewer(file: any) {
    this.selectedFile = file;
    console.log("selected file", this.selectedFile);
    this.isFileViewer = true
  }
  downloadFile(file: any) {
    console.log("selected file", this.selectedFile);
    this.indicatorService.downloadOutcomeProof(this.selectedStrategyId, file.indicator_id, file.outcome_id, file.id).subscribe((x) => {
      console.log("blob", x);
      const blob = new Blob([x], { type: x.type });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = "";
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  }

}
